import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

const ShowTripInfo = ({ tripBookingInfo }) => {
  // console.log(tripBookingInfo);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Trigger animation after mount
    setTimeout(() => setShow(true), 100);
  }, []);

  const containerStyle = {
    border: '1px solid #ccc',
    padding: '20px',
    borderRadius: '10px',
    marginTop: '20px',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    opacity: show ? 1 : 0,
    transform: show ? 'translateY(0)' : 'translateY(20px)',
    transition: 'all 0.5s ease-in-out',
  };

  const formatDateToDDMMYYYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  

  return (
    <div style={containerStyle}>
      <h5 style={{ marginBottom: '15px' }}>Trip Booking Summary</h5>

      <p>
        <Chip
          variant="filled"
          color="primary" 
          label={`Meal Date: ${formatDateToDDMMYYYY(tripBookingInfo?.meal_date)}`}
        />
      </p>
      <p><strong>Meal Name:</strong> {tripBookingInfo?.meal_name}</p>
      <p><strong>Meal Timing:</strong> {tripBookingInfo?.meal_format}</p>
      <p><strong>Restaurant Name:</strong> {tripBookingInfo?.restaurant_name}</p>
      <p><strong>Location:</strong> {tripBookingInfo?.location}</p>

      <p><strong>Pax Details:</strong></p>
      <ul>
        {tripBookingInfo?.pax_data?.map((pax, index) => (
          // eslint-disable-next-line
          <li key={index}>
            {pax.pax_name} - Booked on: {formatDateToDDMMYYYY(tripBookingInfo?.meal_date)}
          </li>
        ))}
      </ul>
    </div>
  );
};

ShowTripInfo.propTypes = {
  tripBookingInfo: PropTypes.shape({
    meal_name: PropTypes.string.isRequired,
    meal_format: PropTypes.string.isRequired,
    restaurant_name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    meal_date: PropTypes.string.isRequired,
    pax_data: PropTypes.arrayOf(
      PropTypes.shape({
        pax_name: PropTypes.string.isRequired,
        booked_on: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default ShowTripInfo;

